import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.any()
export type TagsDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.infer<typeof tagsDeleteDocumentsBuildings_buildingIdDocuments_documentId>

export const descriptionDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.any()
export type DescriptionDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.infer<typeof descriptionDeleteDocumentsBuildings_buildingIdDocuments_documentId>

export const paramsDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.object({ "buildingId": z.string().uuid(), "documentId": z.string().uuid() })
export type ParamsDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.infer<typeof paramsDeleteDocumentsBuildings_buildingIdDocuments_documentId>

export const responseDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.any()
export type ResponseDeleteDocumentsBuildings_buildingIdDocuments_documentId = z.infer<typeof responseDeleteDocumentsBuildings_buildingIdDocuments_documentId>

interface IDeleteDocumentsBuildings_buildingIdDocuments_documentId extends BaseMethodType {
  tags: TagsDeleteDocumentsBuildings_buildingIdDocuments_documentId,
  description: DescriptionDeleteDocumentsBuildings_buildingIdDocuments_documentId,
  params: ParamsDeleteDocumentsBuildings_buildingIdDocuments_documentId,
  response: ResponseDeleteDocumentsBuildings_buildingIdDocuments_documentId
}
export const URL = '/documents/buildings/:buildingId/documents/:documentId'
export const validation = {
  delete: {
    tags: tagsDeleteDocumentsBuildings_buildingIdDocuments_documentId,
    description: descriptionDeleteDocumentsBuildings_buildingIdDocuments_documentId,
    params: paramsDeleteDocumentsBuildings_buildingIdDocuments_documentId,
    response: responseDeleteDocumentsBuildings_buildingIdDocuments_documentId
  }
}
export interface DocumentsBuildings_buildingIdDocuments_documentId extends BaseRouteType {
  delete: IDeleteDocumentsBuildings_buildingIdDocuments_documentId
}